import { ChecksumAlgorithm } from "./constants";
export const getChecksumLocationName = algorithm => algorithm === ChecksumAlgorithm.MD5 ? "content-md5" : `x-amz-checksum-${algorithm.toLowerCase()}`;